import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from "@nextui-org/react";


export function AccountView(props) {
  
  return (
    <div className="container mx-auto px-4 py-8 flex flex-col items-center justify-center">
      <h1 className="text-3xl mb-6 text-center">Account Information</h1>
      <div className="max-w-md w-full border-medium rounded-lg shadow-md p-6">

        <div className="mb-4">
          <label htmlFor="email" className="block font-bold text-gray-700">
            Email:
          </label>
          <p id="email" className="mt-1 text-gray-900">{props.emailAddress}</p>
        </div>
        <div className="mb-4">
          <label htmlFor="username" className="block font-bold text-gray-700">
            Username:
          </label>
          <p id="username" className="mt-1 text-gray-900">{props.username}</p>
        </div>
        <div className="mb-6">
          <label htmlFor="new-username" className="block font-medium text-gray-700">
            Change Username:
          </label>
          <Tooltip
            className="text-tiny text-default-500 rounded-lg"
            content="Username will be saved automatically!"
            placement="top-end"
          >
            <input
              id="new-username"
              type="text"
              value={props.username}
              onChange={(e) => props.setUsername(e.target.value)}
              className="mt-1 p-2 block w-full rounded border border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
            />
          </Tooltip>
        </div>
      </div>
      <Link className="btn-primary mt-10" to="/">
        Home
      </Link>
    </div>
  );
}

export default AccountView;


